//deep extend is only done for config.modules, all other config fields are extended using shallow extend
fpConfig = fp.config = {
    siteTitle: 'Site',
    siteTitleFormat: '{title} | {siteTitle}',
    siteTitleCategoryFormat: '{category} | {siteTitle}',
    storeTitle: 'store',
    storeTitlePlural: 'stores',
    storeAboutUsLabel: 'About Us',
    metaDescription: '{title}',
    urls: {
        account: '/my-account',
        checkout: '/checkout',
        circular: '/weekly-ad',
        circularLanding: '/weekly-ad-landing',
        coupon: '/digital-coupons',
        couponPoint: '/coupon-points',
        home: '/',
        list: '/list',
        notSupported: '/not-supported',
        shopping: '/shop',
        storeLocator: '/my-store/store-locator'
    },
    adminUrl: 'https://admin.freshop.com/',
    gcpAdminUrl: 'https://admin.freshop.ncrcloud.com/',
    rewardTitle: 'My Rewards',
    addToListLabel: 'Add to List',
    addIngredientsToListLabel: 'Add Ingredients to List',
    removeFromListLabel: 'Remove from List',
    inListLabel: '<span class="fp-label-in-list"> in List</span>',
    couponPoint: {
        hasSpecialOffers: false
        ,title: 'My Special Offers'
    },
    myCouponTitle: 'My Digital Coupons',
    clipActionLabel: 'Clip &amp; Save',
    clipActionAgainLabel: 'Clip again &amp; Save',
    clipSaleActionLabel: 'Clip &amp; Save More',
    enablePhoneCountryCode: true,
    productFilters: [
        {	identifier: 'is_featured',
            name: 'Featured'
        },
        {	identifier: 'is_favorite',
            name: 'My Favorites'
        },
        {	identifier: 'is_bought_by_me',
            name: 'Purchased by Me'
        },
        {	identifier: 'is_bought_by_me_in_store',
            name: 'Purchased In Store By Me'
        },
        {	identifier: 'is_on_sale',
            name: 'On Sale'
        },
        {	identifier: 'is_personalized',
            name: 'Just For Me'
        },
        {	identifier: 'store_specials',
            name: 'Store Specials'
        },
        {	identifier: 'has_clippable_offer',
            name: 'Has Digital Coupon'
        },
        {	identifier: 'include_out_of_stock',
            name: 'Include Out of Stock'
        },
        {	identifier: 'in_stock_only',
            name: 'In Stock'
        },
        {	identifier: 'is_top_deal',
            name: 'Top Deals'
        }
    ],
    enableSaleDateMd: true,
    enableCouponDisplayOfferDisclaimer: true,
    cardCodeFormat: 'UPC_A',
    productBarcodeFormat: 'UPC_A',
    enableSaleDateWrap: false,
    enableStoreStateName: true,
    enableSubstitutionCheckbox: false,
    enableFreshopTracking: true,
    enableItemAddedPopover: false,
    enableQuantityIndicator: true,
    enableSaleIndicator: false,
    enableAnimateIn: false, //enableAnimateIn is not working properly (module element is left in freshop container)
    enableAbortErrorLog: true,
    disableAbortErrorLogApis: [
        {path: 'products/ads'},
        //disable abort error logging for BevMo urls/analyze calls
        {path: 'urls/analyze', appKey: 'bevmo'},
        //disable abort error logging for Walter Mart user_product_upsell calls
        {path: 'user_product_upsell', appKey: 'walter_mart'}
    ],
    searchTypeahead: {
        enabled: true,
        datasets: [
            {identifier: 'departments', className: 'fp-tt-department', iconClassName: 'fp-icon-department'},
            {identifier: 'did_you_mean', name: 'Did you mean'},
            {identifier: 'variants', name: 'Try searching'},
            {identifier: 'related', name: 'Related searches'},
            {identifier: 'your_terms', name: 'Recent searches', iconClassName: 'fp-icon-clock'}
        ]
    },
    enableAddressTypeahead: false,
    enableReviewDetailModal: true,
    enableCouponClipping: true,
    enableSearchPlaceholderChange: true,
    enableWebCollage: true,
    enableOrderPlacedIndicator: true,
    departmentLevel: 3,
    includeAddressBook: true,
    enableQtyDropDown: false,
    qtyDropDownMaxAmount: 10,
    pickUpHasEndTime: true,
    enableDisplayProductIndications: false,
    enableMultiplex: false,
    enableInventoryTagsOnGrid: true,
    enableLoadEarlyModules: true,
    disableMajorModuleDelay: true,
    enableLazyInit: true,
    enableUiConfigOverride: true,
    gridShelfTagsMax: 2,
    //disableOrderUpsell: fp.isProd(),
    shopIntent: {
        enabled: false
    },
    guestCheckOut: {
        enabled: false
    },
    formLabels: {},
    checkoutInstructionLabels: {},
    checkoutNoteLabels: {},
    addressFields: {
        enableAbbreviations: true
    },
    account: {
        loginImportantMessage: '<h2>All Customers <span class="fp-custom">must</span> create an account!</h2>',
        loginLabel: '(<span class="fp-semibold">One-time</span>...even if you previously created an account on our previous website.)'
    },
    errorCoupons: 'This location does not support digital coupons',
    globalStoreId: '100',
    adminStoreId: '432',
    storeCard: {
        landingPlaceholder: 'Store Card or Key Tag #',
        profileCardTitle: 'Your Store Card Number',
        cardLabel: 'Store Card',
        checkoutVirtualCardLabel: 'phone number',
        linkLabel: 'Enter Your Store Card Information',
        //,linkCopy: ' \
        //    To link your existing preferred Customer Club Card to your new account, \
        //    please enter all digits located on the back of your card/key tag and click "Continue". \
        //',
        signInContent: 'Please sign in to add coupons.',
        needStoreCardEnabled: false,
        needStoreCardRequired: false
    },
    hasSubstitutions: true,
    productDetailLayout: 'layout-0',
    weightDivider: '|',
    dateFormat: 'MM/DD/YYYY',
    shortDateFormat: 'MM/DD/YY',
    saleDateFormat: 'MM/DD/YY',
    timeFormat: 'h:mm a',
    dateTimeFormat: 'MM/DD/YYYY h:mm a',
    shortDateTimeFormat: 'MM/DD/YY @ h:mma',
    longDateTimeFormat: 'MM/DD/YYYY h:mm:ss a',
    calendarDateFormat: "D m/d",
    fulfillmentDateFormat: 'dddd, MMMM D',
    fulfillmentShortDateFormat: 'ddd MM/DD',
    fulfillmentLongDateFormat: 'dddd MM/DD/YY',
    fulfillmentTimeFormat: 'h:mma',
    fulfillmentShortTimeFormat: 'h:mma', //there is currently no way to represent single digit meridian i.e. 'p' vs 'pm', we will represent it by adding a '-'
    fulfillmentDateTimeDelimiter: ' @ ',
    fulfillmentDateTimeHasEndTimeDelimiter: ' between ',
    numericFormat: '0.00',
    numberFormat: '0,0.00',
    numberFormatShort: '0,0',
    numberFormatOptional: '0,0[.]00',
    currencyFormat: '$0,0.00',
    currencyFormatShort: '$0,0',
    currencyFormatOptional: '$0,0[.]00',
    localePhone: { //this will be overridden by store_locale SPC
        format_input: true,
        default_format: '(000) 000-0000',
        default_country_code: '+1',
        strip_formatting: false
    },
    enableImageOptimization: true,
    imageSizes: {
        product: {
            //xs: 64,
            sm: 64,
            md: 256,
            lg: 512
        },
        recipe: {
            //xs: 64,
            sm: 64,
            md: 256,
            lg: 512
        },
        circular: {
            xs: 420,
            sm: 720,
            md: 940,
            lg: 1140
        },
        renderSequence: [
            'lg',
            'md',
            'sm',
            'xs'
        ],
        map: {
            extra_small: 'xs',
            small: 'sm',
            medium: 'md',
            large: 'lg',
            original: 'lg'
        }
    },
    imageQuality: {
        product: 80,
        recipe: 80,
        circular: 40,
        product_large: 90,
        recipe_large: 90
    },
    genericProductImageUrl: fp.clientAssetBaseUrl + 'img/generic_product',
    genericRecipeImageUrl: fp.clientAssetBaseUrl + 'img/generic_recipe',
    clientShoppingStoreSearchRadius: 25,
    productIncrement: 1,
    cardTypes: {
        visa: 'Visa',
        visaelectron: 'Visa Debit',
        mastercard: 'MasterCard',
        amex: 'American Express',
        discover: 'Discover'
    },
    cardTypeCodes: {
        visa: '001',
        visaelectron: '001',
        mastercard: '002',
        amex: '003',
        discover: '004'
    },
    emailTemplateStatus: [{
        id: '1',
        identifier: 'enabled',
        name: 'Enabled'
    }, {
        id: '2',
        identifier: 'disabled',
        name: 'Disabled'
    }],
    //GA 3 -- old global tracking ID
    // gaTrackingId: 'UA-76428239-29',
    //Google Tag Manager
    gtmId: 'GTM-PH7VMTJ',
    //GA 4 -- this will be loaded via GTM
    gaTrackingId: 'G-0MCW5VWV52',
    modules: {
        account: {
            isView: true,
            modules: {
                login: {},                
                create: {},
                activateAccount: {},
                forgot: {},
                forgotReset: {},
                orders: {},
                orderDetails: {},
                receipts: {},
                receiptDetails: {},
                inStoreReceiptList: {},
                lists: {},
                profile: {},
                security: {},
                reward: {},
                rewardHistoryList: {},
                purchaseHistoryList: {},
                loyaltyDetail: {},
                paymentMethodList: {},
                paymentMethodEdit: {},
                addressBook: {},
                membershipSubscription: {},
                productSubscription: {},
                balanceChecker: {},
                balanceCheckerAcculynk: {},
                storeCardList: {}
            }
        },
        circular: {
            isView: true
        },
        coupon: {
            isView: true
        },
        couponPoint: {
            isView: true
        },
        enroll: {
            isView: true
        },
        circular: {
            isView: true
        },
        list: {
            isView: true
        },
        recipe: {
            isView: true/*,
            enableRecipeCategories: true*/
        },
        recipeDetail: {
            isView: true
        },
        itemGridCategory: {
            isView: true
        },
        groupCarousel: {
            isView: true
        },
        products: {
            isView: true/*,
            enableComponentCss: true,
            enableProductCategories: true*/
        },
        productDetail: {
            isView: true/*,
            enableModuleCss: true,
            enableComponentCss: true*/
        },
        storeLocator: {
            isView: true/*,
            enableModuleCss: true,
            enableComponentCss: true*/
        },
        subAppSearch: {
            isView: true
        },
        checkout: {
            path: 'checkout/checkout',
            isView: true,
            modules: {
                pickup: {
                    name: 'checkout/pickup',
                    inherit: 'checkout/fulfillment',
                    fulfillmentIdentifier: 'pickup',
                    enableStoreSlots: true,
                    enableDisplayStore: true
                },
                delivery: {
                    name: 'checkout/delivery',
                    inherit: 'checkout/fulfillment',
                    fulfillmentIdentifier: 'delivery',
                    enableStoreSlots: true,
                    enableAddress: true/*,
                    enableDisplayStore: true*/
                },
                inLaneDelivery: {
                    name: 'checkout/in-lane-delivery',
                    inherit: 'checkout/delivery',
                    fulfillmentIdentifier: 'in_lane_delivery',
                    enableStoreSlots: true,
                    enableAddress: true
                },
                digital: {
                    name: 'checkout/digital',
                    inherit: 'checkout/fulfillment',
                    fulfillmentIdentifier: 'digital'
                },
                dropOff: {
                    name: 'checkout/drop-off',
                    inherit: 'checkout/fulfillment',
                    fulfillmentIdentifier: 'drop_off', 
                    enableStoreSlots: true
                },
                dropShip: {
                    name: 'checkout/drop-ship',
                    inherit: 'checkout/fulfillment'
                },
                review: {
                    name: 'checkout/review',
                    inherit: 'checkout/checkout'
                },
                payment: {
                    name: 'checkout/payment'
                },
                confirmation: {
                    name: 'checkout/confirmation',
                    inherit: 'checkout/checkout'
                },
                fulfillmentLanding: {
                    isView: true,
                    fulfillmentOptions: {
                        pickup: {
                            subTitle: 'Pick up your groceries in store',
                            body: 'Order now for pick up {0}!'
                        },
                        delivery: {
                            subTitle: 'Have your groceries delivered to your house',
                            body: 'Order now for delivery {0}!'
                        },
                        in_lane_delivery: {
                            subTitle: 'Have your groceries delivered to your house',
                            body: 'Order now for delivery {0}!'
                        },
                        drop_off: {
                            subTitle: 'Have your groceries dropped off at your location',
                            body: 'Order now for drop-off {0}!'
                        },
                        drop_ship: {
                            subTitle: 'Ship your order today',
                            body: 'Your order can be shipped {0}!'
                        }
                    }
                }
            }
        }/*,
        tracking: {
            layout: "layout-1"
        }*/
    },
    routeStates: { //data is inherited by child routes
        //Account
        account: {
            name: 'account',
            url: '{{account}}',
            controller: 'account',
            menuParent: 'account',
            includeInMenu: true,
            menuSequence: 0,
            data: {
                title: 'My Account',
                authenticate: true
            }
        },
        accountSecurity: {
            name: 'account-security',
            url: '/security',
            controller: 'security',
            parent: 'account',
            includeInMenu: function() {
                const userAuthenticationType = fpUtil.map.get('spcUserAuthenticationType'),
                    usernamePassword = userAuthenticationType.get('username_password'),
                    mfaOptions = usernamePassword.config?.mfa_options;
                return fpUtil.getBoolean(usernamePassword.id && (userAuthenticationType.get('passwordless_auth').id || mfaOptions?.authenticator?.enabled));
            },
            menuSequence: 1,
            data: {
                title: 'My Security'
            }
        },
        accountAddressBook: {
            name: 'account-address-book',
            url: '/address',
            controller: 'address-book',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return !fp.user.is_guest_user && fpConfig.includeAddressBook;
            },
            menuSequence: 1,
            data: {
                title: 'My Address Book'
            }
        },
        accountMembershipSubscription: {
            name: 'account-membership-subscription',
            url: '/membership-subscription',
            controller: 'membership-subscription',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return !fp.user.is_guest_user && fp.hasProductSubscriptions;
            },
            menuSequence: 1,
            data: {
                title: 'My Membership Subscriptions'
            }
        },
        accountProductSubscription: {
            name: 'account-product-subscription',
            url: '/product-subscription',
            controller: 'product-subscription',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return !fp.hideProductSubscriptionMenu && !fp.user.is_guest_user && fp.hasProductSubscriptions;
            },
            menuSequence: 1,
            data: {
                title: 'My Product Subscriptions'
            }
        },
        accountPaymentMethod: {
            name: 'payment-method-list',
            url: '/payment-methods',
            controller: 'payment-method-list',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return !fp.user.is_guest_user && (fpUtil.getInteger(fp.user.payment_method_count) > 0 || (fp.hasStoreFulfillment() && fp.hasSavedPayment));
            },
            menuSequence: 2,
            data: {
                title: 'My Payment Methods'
            }
        },
        accountPaymentMethodEdit: {
            name: 'payment-method-edit',
            url: '?id',
            controller: 'payment-method-edit',
            isShoppingExclusive: true,
            parent: 'payment-method-list',
            data: {
                title: 'Payment Method Details'
            }
        },
        accountOrder: {
            name: 'account-order-list',
            url: '/orders',
            controller: 'order-list',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return fpUtil.getInteger(fp.user.order_count) > 0 || fp.hasStoreFulfillment();
            },
            menuSequence: 3,
            data: {
                title: 'My Orders'
            }
        },
        accountOrderDetail: {
            name: 'account-order-detail',
            url: '?id',
            controller: 'order-detail',
            isShoppingExclusive: true,
            parent: 'account-order-list',
            data: {
                title: 'Order Details'
            }
        },
        accountReceipt: {
            name: 'account-receipt-list',
            url: '/receipts',
            controller: 'receipt-list',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return fp.hasInStoreReceipt;
            },
            menuSequence: 4,
            data: {
                title: function() {
                    var config = fpUtil.map.get('spcOrderData').get('in_store_receipt', null, true).config;
                    return (config && config.list_page_label) || 'My Receipts';
                }
            }
        },
        accountReceiptDetail: {
            name: 'account-receipt-detail',
            url: '?id',
            controller: 'receipt-detail',
            isShoppingExclusive: true,
            parent: 'account-receipt-list',
            data: {
                title: function() {
                    var config = fpUtil.map.get('spcOrderData').get('in_store_receipt', null, true).config;
                    return (config && config.detail_page_label) || 'Receipt Details';
                }
            }
        },
        accountInStoreReceipt: {
            name: 'account-in-store-receipt-list',
            url: '/in-store-receipts',
            controller: 'in-store-receipt-list',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return fp.hasInStoreOrder;
            },
            menuSequence: 4,
            data: {
                title: 'My In Store Receipts'
            }
        },
        accountList: {
            name: 'account-list',
            url: '/lists',
            controller: 'list-list',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: true,
            menuSequence: 5,
            data: {
                title: 'My Shopping Lists'
            }
        },
        accountReward: {
            name: 'account-reward',
            url: '/reward',
            controller: 'reward',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return !fp.user.is_guest_user && fp.hasReward;
            },
            menuSequence: 6,
            data: {
                title: function() {
                    return fpConfig.reward && fpConfig.reward.rewardTitle ? fpConfig.reward.rewardTitle : 'My Rewards';
                }
            }
        },
        accountRewardHistory: {
            name: 'account-reward-history-list',
            url: '/reward-history',
            controller: 'reward-history-list',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return !fp.user.is_guest_user && fp.hasRewardHistory;
            },
            menuSequence: 6,
            data: {
                title: function() {
                    return fp.rewardHistoryConfig.rewardTitle ? fp.rewardHistoryConfig.rewardTitle : 'My Reward History';
                }
            }
        },
        accountPurchaseHistory: {
            name: 'account-purchase-history-list',
            url: '/purchase-history',
            controller: 'purchase-history-list',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return fpConfig.enablePurchaseHistory;
            },
            menuSequence: 7,
            data: {
                title: 'My Purchase History'
            }
        },
        accountLoyaltyDetail: {
            name: 'account-loyalty-detail',
            url: '/loyalty-detail',
            controller: 'loyalty-detail',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return _.size(fpUtil.getValueFromNamespace('modules.account.modules.loyaltyDetail', fpConfig));
            },
            menuSequence: 7,
            data: {
                title: 'My Loyalty Details'
            }
        },
        accountBalanceChecker: {
            name: 'account-balance-checker',
            url: '/balance-checker',
            controller: 'balance-checker',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return _.size(fpUtil.getValueFromNamespace('modules.account.modules.balanceChecker', fpConfig));
            },
            menuSequence: 8,
            data: {
                title: 'My Gift Cards'
            }
        },
        accountAcculynkBalanceChecker: {
            name: 'account-balance-checker-acculynk',
            url: '/balance-checker-acculynk',
            controller: 'balance-checker-acculynk',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                //enable_balance_check should not disable account balance check
                return (fpUtil.map.get('storePaymentType').get('acculynk_snap').id || fpUtil.map.get('storePaymentType').get('acculynk_cash').id) != null
            },
            menuSequence: 8,
            data: {
                title: 'My EBT Card Balance'
            }
        },
        accountStoreCardList: {
            name: 'account-store-card-list',
            url: '/my-cards',
            controller: 'store-card-list',
            isShoppingExclusive: true,
            parent: 'account',
            includeInMenu: function() {
                return _.size(fpUtil.getValueFromNamespace('modules.account.modules.storeCardList', fpConfig));
            },
            menuSequence: 9,
            data: {
                title: function() {
                    const storeCardModuleConfig = fpUtil.getValueFromNamespace('modules.account.modules.storeCardList', fpConfig);
                    let title = 'My Cards';
                    if(storeCardModuleConfig?.title) {
                        title = storeCardModuleConfig.title;
                    }
                    return title;
                }
            }
        },
        login: {
            name: 'login',
            url: '/login',
            controller: 'login',
            parent: 'account',
            data: {
                title: 'Login',
                authenticate: false,
                isAuthenticatedRedirect: 'account',
                disableBreadcrumb: true,
                enableOauthLoginUrl: true
            }
        },
        accountCreate: {
            name: 'account-create',
            url: '/create',
            controller: 'create',
            parent: 'account',
            data: {
                title: 'Create Account',
                authenticate: false,
                isAuthenticatedRedirect: 'account',
                disableBreadcrumb: true,
                enableOauthLoginUrl: true
            }
        },
        accountCreateParam: {
            name: 'account-create-param',
            url: '?create',
            controller: 'create',
            parent: 'account',
            data: {
                title: 'Create Account',
                authenticate: false,
                isAuthenticatedRedirect: 'account',
                disableBreadcrumb: true,
                enableOauthLoginUrl: true
            }
        },
        accountActivate: {
            name: 'account-activate',
            url: '/activate',
            controller: 'activate-account',
            parent: 'account',
            data: {
                title: 'Activate Account',
                authenticate: false
            }
        },
        accountActivateParam: {
            name: 'account-activate-param',
            url: '/activate?actvate_token',
            controller: 'activate-account',
            parent: 'account',
            data: {
                title: 'Activate Account',
                authenticate: false
            }
        },
        accountForgot: {
            name: 'account-forgot',
            url: '/forgot',
            controller: 'forgot',
            parent: 'account',
            data: {
                title: 'Forgot Password',
                authenticate: false,
                disableBreadcrumb: true
            }
        },
        accountForgotReset: {
            name: 'account-forgot-reset',
            url: '/reset',
            controller: 'forgot-reset',
            parent: 'account-forgot',
            data: {
                title: 'Forgot Password',
                authenticate: false
            }
        },
        accountForgotResetParam: {
            name: 'account-forgot-reset-param',
            url: '?reset_token',
            controller: 'forgot-reset',
            parent: 'account',
            data: {
                title: 'Forgot Password',
                authenticate: false
            }
        },
        logout: {
            name: 'logout',
            url: '/logout',
            parent: 'account',
            data: {
                title: 'Logout',
                authenticate: false,
                disableBreadcrumb: true
            }
        },
        accountCreationComplete: {
            name: 'account-complete',
            url: '{{accountCreationComplete}}',
            data: {
                title: 'Account Create Complete'
            }
        },
        loyaltyRegistration: {
            name: 'loyalty-registration',
            url: '{{loyaltyRegistration}}',
            data: {
                title: 'Loyalty Registration'
            }
        },
        list: {
            name: 'list',
            url: '{{list}}',
            isShoppingExclusive: true,
            includeInMenu: true,
            menuSequence: 1,
            data: {
                title: 'List'
            }
        },
        storeLocator: {
            name: 'store-locator',
            url: '{{storeLocator}}',
            isShoppingExclusive: true,
            includeInMenu: true,
            menuSequence: 2,
            data: {
                title: 'Store Locator'
            }
        },
        product: {
            name: 'shop',
            url: '{{shopping}}',
            isShoppingExclusive: true,
            includeInMenu: true,
            menuSequence: 3,
            enableSEO: true,
            data: {
                title: 'Shop'
            }
        },
        productCategory: {
            name: 'product-category',
            //url: '/{slug:path}/d/{department_id:.*}',
            url: '/{slug:path}/d/{department_id:[\\w-]+}{route:.*}',
            isShoppingExclusive: true,
            params: {
                slug: {
                    value: 'departments',
                    squash: true
                },
                route: {
                    emit: false,
                    squash: true,
                    raw: true
                }
            },
            parent: 'shop',
            enableSEO: true,
            disableConcat: true,
            data: {
                title: 'Product Category',
                cssClass: 'fp-state-product'
            }
        },
        //keep productFavorite state until we convert all WP sites to use parameter style
        productFavorite: {
            name: 'product-my-favorites',
            url: '/my-favorites',
            redirect: 'product-my-favorites-param',
            parent: 'shop',
            data: {
                title: 'My Favorites',
                authenticate: true
            }
        },
        productFavoriteParam: {
            name: 'product-my-favorites-param',
            url: '/?{filter:(?:is_favorite)}',
            params: {
                filter: 'is_favorite'
            },
            mapToParentState: true,
            parent: 'shop',
            includeInMenu: true,
            menuSequence: 4,
            menuParent: 'account',
            data: {
                title: 'My Favorites',
                authenticate: true
            }
        },
        //productFeatured: {name: 'product-featured', url: '/featured', parent: 'shop', data: {title: 'Featured'}},
        productFeatured: {
            name: 'product-featured',
            url: '/?{filter:(?:is_featured)}',
            params: {
                filter: 'is_featured'
            },
            mapToParentState: true,
            parent: 'shop',
            data: {
                title: 'Featured'
            }
        },
        productDetail: {
            name: 'product-detail',
            url: '?id',
            parent: 'shop',
            enableSEO: true,
            data: {
                title: 'Product Details'
            }
        },
        productDetailParam: {
            name: 'product-detail-param',
            url: '?product_id',
            parent: 'shop',
            enableSEO: true,
            data: {
                title: 'Product Details'
            }
        },
        productDetailRoute: {
            name: 'product-detail-route',
            url: '{slug:path}/p/{product_id:[\\w-]+}{route:.*}',
            params: {
                slug: {
                    value: 'product',
                    squash: true
                },
                route: {
                    emit: false,
                    squash: true,
                    raw: true
                }
            },
            parent: 'shop',
            enableSEO: true,
            data: {
                title: 'Product Details'
            }
        },
        productCategoryDetailRoute: {
            name: 'product-category-detail-route',
            url: '/departments/{slug:path}/p/{product_id:[\\w-]+}{route:.*}',
            params: {
                slug: {
                    value: 'product',
                    squash: true
                },
                route: {
                    emit: false,
                    squash: true,
                    raw: true
                }
            },
            parent: 'product-category',
            enableSEO: true,
            disableConcat: true,
            data: {
                title: 'Product Details'
            }
        },
        recipe: {
            name: 'recipe',
            url: '{{recipe}}',
            isShoppingExclusive: true,
            includeInMenu: true,
            menuSequence: 4,
            enableSEO: true,
            data: {
                title: 'Recipes'
            }
        },
        recipeCategory: {
            name: 'recipe-category',
            url: '/{slug:path}/c/{category_id:[\\w-]+}{route:.*}',
            isShoppingExclusive: true,
            params: {
                slug: {
                    value: 'categories',
                    squash: true
                },
                route: {
                    emit: false,
                    squash: true,
                    raw: true
                }
            },
            parent: 'recipe',
            enableSEO: true,
            disableConcat: true,
            data: {
                title: 'Recipe Category',
                cssClass: 'fp-state-recipe'
            }
        },
        //recipeFavorite: {name: 'recipe-my-recipes', url: '/my-recipes', data: {title: 'My Recipes', authenticate: true}},
        recipeFavorite: {
            name: 'recipe-my-recipes',
            url: '/?{filter:(?:is_favorite)}',
            params: {
                filter: 'is_favorite'
            },
            mapToParentState: true,
            parent: 'recipe',
            menuParent: 'account',
            includeInMenu: function() {
                return !fpUtil.isNull(fpConfig.urls.recipe) && !(fp.isProd() && fpConfig.disableRecipeMenu);
            },
            menuSequence: 4,
            data: {
                title: function() {
                    return fp.ui.locale('recipe-my-recipes', 'My Recipes')
                },
                authenticate: true
            }
        },
        //recipeFeatured: {name: 'recipe-featured', url: '/featured', parent: 'recipe', data: {title: 'Featured'}},
        recipeFeatured: {
            name: 'recipe-featured',
            url: '/?{filter:(?:is_featured)}',
            params: {
                filter: 'is_featured'
            },
            parent: 'recipe',
            data: {
                title: 'Featured'
            }
        },
        recipeDetail: {
            name: 'recipe-detail',
            url: '?id',
            parent: 'recipe',
            enableSEO: true,
            data: {
                title: 'Recipe Details'
            }
        },
        recipeDetailParam: {
            name: 'recipe-detail-param',
            url: '?recipe_id',
            parent: 'recipe',
            enableSEO: true,
            data: {
                title: 'Recipe Details'
            }
        },
        recipeDetailRoute: {
            name: 'recipe-detail-route',
            url: '{slug:path}/r/{recipe_id:[\\w-]+}{route:.*}',
            params: {
                slug: {
                    value: 'recipe',
                    squash: true
                },
                route: {
                    emit: false,
                    squash: true,
                    raw: true
                }
            },
            parent: 'recipe',
            enableSEO: true,
            data: {
                title: 'Recipe Details'
            }
        },
        recipeCategoryDetailRoute: {
            name: 'recipe-category-detail-route',
            url: '/bundles/{slug:path}/r/{recipe_id:[\\w-]+}{route:.*}',
            params: {
                slug: {
                    value: 'recipe',
                    squash: true
                },
                route: {
                    emit: false,
                    squash: true,
                    raw: true
                }
            },
            parent: 'recipe-category',
            enableSEO: true,
            disableConcat: true,
            data: {
                title: 'Recipe Details'
            }
        },
        weeklyAdLanding: {
            name: 'weekly-ad-landing',
            url: '{{circularLanding}}',
            isShoppingExclusive: true,
            data: {
                title: 'Weekly Ads'
            }
        },
        weeklyAd: {
            name: 'weekly-ad',
            url: '{{circular}}',
            isShoppingExclusive: true,
            includeInMenu: true,
            menuSequence: 4,
            data: {
                title: 'Weekly Ad'
            }
        },
        //weeklyAdFeatured: {name: 'weekly-ad-featured', url: '/featured', parent: 'weekly-ad', data: {title: 'Featured Offers'}},
        weeklyAdFeatured: {
            name: 'weekly-ad-featured',
            url: '/?{filter:(?:is_featured)}',
            params: {
                filter: 'is_featured'
            },
            mapToParentState: true,
            parent: 'weekly-ad',
            data: {
                title: 'Featured Offers'
            }
        },
        coupon: {
            name: 'coupon',
            url: '{{coupon}}',
            isShoppingExclusive: true,
            includeInMenu: function() {
                return fpUtil.getBoolean(fp.hasDigitalCoupon);
            },
            menuSequence: 5,
            data: {
                title: 'Digital Coupons'
            }
        },
        //myCoupon: {name: 'coupon-my-coupons', url: '/my-coupons', parent: 'coupon', data: {title: 'My Digital Coupons', authenticate: true }},
        myCoupon: {
            name: 'coupon-my-coupons',
            url: '/?{filter:(?:is_clipped)}',
            params: {
                filter: 'is_clipped'
            },
            mapToParentState: true,
            parent: 'coupon',
            menuParent: 'account',
            includeInMenu: function() {
                return fpUtil.getBoolean(fp.hasDigitalCoupon);
            },
            menuSequence: 4,
            data: {
                title: function() {
                    return fp.myCouponTitle ? fp.myCouponTitle : 'My Digital Coupons';
                },
                authenticate: true
            }
        },
        couponPoint: {
            name: 'coupon-point',
            url: '{{couponPoint}}',
            isShoppingExclusive: true,
            includeInMenu: function() {
                return fpUtil.getBoolean(fp.hasDigitalCoupon);
            },
            data: {
                title: 'Special Offers'
            }
        },
        myCouponPoint: {
            name: 'coupon-point-my-coupons',
            url: '/?{filter:(?:is_clipped)}',
            params: {
                filter: 'is_clipped'
            },
            mapToParentState: true,
            parent: 'coupon-point',
            menuParent: 'account',
            includeInMenu: function() {
                return fpConfig.couponPoint && fpConfig.couponPoint.hasSpecialOffers;
            },
            menuSequence: 7,
            data: {
                title: function() {
                    return fpConfig.couponPoint && fpConfig.couponPoint.title ? fpConfig.couponPoint.title : 'My Special Offers';
                },
                authenticate: true
            }
        },
        checkout: {
            name: 'checkout',
            url: '{{checkout}}',
            isShoppingExclusive: true,
            includeInMenu: true,
            menuSequence: 6,
            data: {
                title: 'Checkout',
                authenticate: true
            }
        },
        checkoutPickup: {
            name: 'checkout-pickup',
            url: '/pickup',
            controller: 'checkout/pickup',
            parent: 'checkout',
            data: {
                title: 'Checkout Pickup'
            }
        },
        checkoutDelivery: {
            name: 'checkout-delivery',
            url: '/delivery',
            controller: 'checkout/delivery',
            parent: 'checkout',
            data: {
                title: 'Checkout Delivery'
            }
        },
        checkoutInLaneDelivery: {
            name: 'checkout-in_lane_delivery',
            url: '/in_lane_delivery',
            controller: 'checkout/in-lane-delivery',
            parent: 'checkout',
            data: {
                title: 'Checkout In-lane Delivery'
            }
        },
        checkoutDigital: {
            name: 'checkout-digital',
            url: '/digital',
            controller: 'checkout/digital',
            parent: 'checkout',
            data: {
                title: 'Checkout Digital'
            }
        },
        checkoutDropOff: {
            name: 'checkout-drop_off',
            url: '/drop_off',
            controller: 'checkout/drop-off',
            parent: 'checkout',
            data: {
                title: 'Checkout Drop-Off'
            }
        },
        checkoutDropShip: {
            name: 'checkout-drop_ship',
            url: '/drop_ship',
            controller: 'checkout/drop-ship',
            parent: 'checkout',
            data: {
                title: 'Checkout Drop Ship'
            }
        },
        checkoutReview: {
            name: 'checkout-review',
            url: '/review',
            controller: 'checkout/review',
            parent: 'checkout',
            data: {
                title: 'Checkout Review'
            }
        },
        checkoutConfirmation: {
            name: 'checkout-confirmation',
            url: '/confirmation',
            controller: 'checkout/confirmation',
            parent: 'checkout',
            data: {
                title: 'Checkout Confirmation',
                authenticate: true
            }
        }
    }
};
